<template>
    <div class="legendblock" v-if="options">
               
                <div class="icon-text">
                    <span class="icon">
                        <i class="fas fa-exchange-alt"></i>
                    </span>
                    <span>&nbsp;A rencontré un des joueurs</span>
                </div>
                <div class="icon-text">
                    <span class="icon has-text-dark">
                        <i class="fas fa-user-friends "></i>
                    </span>
                    <span>&nbsp;Coéquipié avec un des joueurs</span>
                </div>
                <div class="icon-text">
                    <span class="icon has-text-dark">
                        <i class="fas fa-list-ol "></i>
                    </span>
                    <span v-if="options.nbJoueursParEquipe==2">&nbsp;A joué une triplette !</span>
                    <span v-if="options.nbJoueursParEquipe==3">&nbsp;A joué une doublette</span>
                </div>
                <div class="icon-text">
                    <span class="icon has-text-dark">
                        <i class="fas fa-stream"></i>
                    </span>
                     <span v-if="options.nbJoueursParEquipe==2">&nbsp;A joué contre une triplette</span>
                    <span v-if="options.nbJoueursParEquipe==3">&nbsp;A joué contre une doublette</span>
                </div>
                 <div class="icon-text">
                    <span class="icon has-text-dark">
                        <i class="fas fa-people-arrows "></i>
                    </span>
                    <span>&nbsp;A joué un des joueurs</span>
                </div>
                <div class="icon-text">
                    <span class="icon has-text-dark">
                        <i class="fas fa-street-view "></i>
                    </span>
                    <span>&nbsp;A déjà été blanc</span>
                </div>
    </div>
</template>
<script>
export default {
    props:["options"]
}
</script>
<style scoped>
 .legendblock {
        width: 650px; 
        text-align: left;
        font-size: 12px;
        border: thin solid black;
        position: fixed;
        top: 3px;
        left: 5px;
        z-index: 100;
        background-color: white;
        height: 50px;
        color: black;
        font-weight: bolder;
    }
    .titleLegend {
        font-weight: bolder;
    }
    .legendblock div {
        margin-bottom: 0px;
        padding: 0px;
        display: inline-block;
        width: 200px;
    } 
</style>